<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">信息审核</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em" @change="sexChange">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证：</label>
          <el-select v-model="identityState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in identityStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>芝麻认证：</label>
          <el-select v-model="zhimaState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in zhimaStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>百度认证：</label>
          <el-select v-model="baiduState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in baiduStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in identityStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>提交类型：</label>
          <el-select v-model="submitType" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in submitTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>进入：</label>
          <el-select v-model="enterState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in enterStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="resumeState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in resumeStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>优质用户：</label>
          <el-select v-model="qualityState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in qualityStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>首页推荐：</label>
          <el-select v-model="homeMatch" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in homeMatchArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐身状态：</label>
          <el-select v-model="userSettingHiding" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in userSettingHidingArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>公开性：</label>
          <el-select v-model="openState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in openStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号类型：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>用户标签：</label>
          <el-select v-model="userTag" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in userTagArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>推荐用户：</label>
          <el-select v-model="recommend" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in recommendArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>异常用户：</label>
          <el-select v-model="abnormalState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in abnormalStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>用户IP状态：</label>
          <el-select v-model="ipState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in ipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>年龄异常：</label>
          <el-select v-model="ageAbnormal" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in ageAbnormalArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>VIP：</label>
          <el-select v-model="vipState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐藏用户：</label>
          <el-select v-model="del" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in delArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>后台评分：</label>
          <el-select v-model="scoreId" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in scoreIdArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>专区：</label>
          <el-select v-model="specialId" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in specialIdArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-checkbox v-model="specialAbduce" style="margin-left: 8px;">外展</el-checkbox>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="出生日期：" @date="getBirthdayTime($event)" @check="getBirthdayCheck($event)" :isChecked="isBirthdayChecked"/>
        </div>
        <div class="content-input-item">
          <label>关注类型：</label>
          <el-select v-model="focusState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in focusStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>月收入：</label>
          <el-select v-model="salaryMin" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in salaryMinArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.value > -1 && item.value > salaryMax && salaryMax > -1">
            </el-option>
          </el-select>
          &nbsp;-&nbsp;
          <el-select v-model="salaryMax" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in salaryMaxArray" :key="item.value" :label="item.label" :value="item.value"  :disabled="item.value >  -1 && item.value < salaryMin && salaryMin > -1">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item" v-if="isLinlu">
          <label>年收入：</label>
          <el-select v-model="annualSalary" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in annualSalaryList" :key="item.type" :label="item.name" :value="item.type">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item" v-if="isLinlu">
          <label>学历认证：</label>
          <el-select v-model="eduAuthState " placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in eduAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身高：</label>
          <el-select v-model="heightMin" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in heightMinArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.value > -1 && item.value > heightMax && heightMax > -1">
            </el-option>
          </el-select>
          &nbsp;-&nbsp;
          <el-select v-model="heightMax" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in heightMaxArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.value > -1 && item.value < heightMin && heightMin > -1">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="封号时间：" @date="getForbiddenTime($event)" @check="getForbiddenCheck($event)" :isChecked="isForbiddenChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="更新日期：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <ChannelPackageList :packageName="packageName" :channel="channel" @getChange="getChannelPackage" />
        </div>

        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="primary" @click="updateScore">评分</el-button>
          <el-button type="primary" @click="batchPass" v-loading="bitchPassLoading">批量通过</el-button>
          <el-button type="danger"  @click="batchReject">批量不通过</el-button>
          <el-button type="primary" @click="updateSpecial">专区操作</el-button>
          <el-button type="primary" @click="voucherAwardA">发送代金券</el-button>
          <el-button type="primary" @click="batchOpen(2)" v-loading="openLoading">公开</el-button>
          <el-button type="danger"  @click="batchOpen(3)" v-loading="notOpenLoading">不公开</el-button>
          <el-button v-if="isLinlu" type="primary" @click="updateHomeMatch(1)" v-loading="matchLoading">设为推荐</el-button>
          <el-button v-if="isLinlu" type="danger"  @click="updateHomeMatch(2)" v-loading="matchLoading">设为不推荐</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
            :row-key="rowKey"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor" :reserve-selection="true"/>
          <el-table-column property="updateTime" label="时间" v-if="checkColList.indexOf('时间') > -1" min-width="104">
            <template #default="scope">
              <div style="margin-bottom: 24px">
                <p>更新时间：</p>
                <p>{{scope.row.updateTime}}</p>
              </div>
              <div style="margin-bottom: 24px">
                <p>登录时间：</p>
                <p>{{scope.row.loginTime}}</p>
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column property="" label="专区类型"  width="90">-->
<!--            <template #default="scope">-->
<!--              <p v-for="(item, index) in scope.row.specialsUserList" :key="index" style="margin: 8px 0;">-->
<!--                <span style="color: #409eff; cursor: pointer;" @dblclick="removeSpecialUser(scope.$index,index)">{{ item.name }}</span>-->
<!--                {{ item.isShow==1?'(外展)':'' }}-->
<!--              </p>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column property="updateTime" label="身份证照" v-if="checkColList.indexOf('身份证照') > -1" width="106">-->
<!--            <template #default="scope">-->
<!--              <GetPlain :side="1" :url="scope.row.identityAuth.imgZ" :uid="scope.row.uid" :type="12" :subType="0"/>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="420">
            <template #default="scope">
              <div style="display: flex; justify-content: flex-end">
                <div  style="margin-right: 12px">
                  <div v-if="scope.row.lastHeadImg" style="width: 80px; height: 80px; position: relative; margin-bottom: 12px">
                    <HeadImg :images="scope.row.lastHeadImg" />
                    <p class="img-history-tag">上一次头像</p>
                  </div>
                  <p class="history-btn" @click="openHeadImgList(scope.row)">历史头像</p>

                  <div v-if="scope.row.identityAuth" style="width: 80px; height: 80px; position: relative; margin: 12px 0">
                    <GetPlain :side="1" :url="scope.row.identityAuth.imgZ" :uid="scope.row.uid" :type="12" :subType="0"/>
                    <p class="img-history-tag">身份证照</p>
                  </div>

                  <div style="margin-top: 12px;" v-if="scope.row.specialsUserList && scope.row.specialsUserList.length > 0">
                    <p>专区类型:</p>
                    <p v-for="(item, index) in scope.row.specialsUserList" :key="index" style="margin: 4px 0;">
                      <span style="color: #409eff; cursor: pointer;" @dblclick="removeSpecialUser(scope.$index,index)">{{ item.name }}</span>
                      {{ item.isShow==1?'(外展)':'' }}
                    </p>
                  </div>

                </div>
                <div v-if="scope.row.headImg" style="position: relative">
                  <p class="img-now-tag">当前头像</p>
                  <HeadImgResume size="300px" :images="scope.row.headImg" />
                </div>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="240">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city" :from="2"/>
<!--              <p>期望结婚时间：<span v-if="scope.row.marryTime">{{scope.row.marryTime == 1? "半年内" : scope.row.marryTime - 1 + "年内"}}</span></p>-->
              <p>身高：{{scope.row.height}}cm</p>
              <p>月收入：<span v-if="scope.row.salaryMin">{{scope.row.salaryMin == -1 ? '不限' : scope.row.salaryMin}}-{{scope.row.salaryMax == -1 ? '不限' : scope.row.salaryMax + 'k'}}</span></p>
              <p style="display: flex; align-items: center;">
                手输：{{scope.row.birthday}}
                <span style="color: #E6A23C; margin-left: 4px;display: flex; align-items: center" v-if="scope.row.identityAuth.ageAbnormal == 2">
                  <ElIcons color="#E6A23C" name="WarningFilled" size="16" /><span style="font-size: 12px;margin-left: 2px;">年龄异常</span>
                </span>
                <span style="color: #E6A23C; margin-left: 4px;display: flex; align-items: center" v-if="scope.row.identityAuth.ageAbnormal == 0">
                  <ElIcons color="#E6A23C" name="WarningFilled" size="16" /><span style="font-size: 12px;margin-left: 2px;">未处理</span>
                </span>
              </p>
              <p>系统：{{scope.row.sysBirthday?scope.row.sysBirthday:scope.row.birthday}}</p>
              <div style="display: flex; align-items: center">
                推荐分数：
                <input class="scoreInput" type="text" v-model="scope.row.recommendScore" placeholder="未推荐" @input="scope.row.scoreSub = true"/>
                <div v-show="scope.row.scoreSub" class="scoreBtn" @click="addRecommend(scope.$index, scope.row)"><ElIcons name="Finished" color="#ffffff"/></div>
              </div>
              <p>代金券：{{scope.row.voucherNum.usedNum}}/{{scope.row.voucherNum.totalNum}}</p>
              <p>融云ID：<span>{{scope.row.rcImAccount}}</span></p>
            </template>
          </el-table-column>

          <el-table-column property="" label="相册" v-if="checkColList.indexOf('相册') > -1" width="180">
            <template #default="scope">
              <el-space wrap :size="4">
                <div v-for="(item,index) in scope.row.photoList.slice(0,8)" style="width: 72px; height: 72px">
                  <el-image style="width: 72px; height: 72px" :src="item.smallImg" fit="cover" @click="showImg(index, scope.row.photoList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </el-space>
              <p v-if="scope.row.photoList.length > 8" class="photo-tip" @click="showImgList(scope.row)">共{{scope.row.photoList.length}}张照片</p>
            </template>
          </el-table-column>

          <el-table-column property="" label="关于我/自我介绍" v-if="checkColList.indexOf('关于我/自我介绍') > -1" min-width="170" class-name="cursor">
            <template #default="scope">
              <p style="font-weight: bold; color: #333333" v-if="scope.row.pdesc" v-high-light="{color1: '#409eff', color2: '#409eff', value: scope.row.pdesc}">{{ scope.row.pdesc }}</p>
            </template>
          </el-table-column>

          <el-table-column label="认证状态" v-if="checkColList.indexOf('认证状态') > -1" width="170">
            <template #default="scope">
              <p>身份认证：{{scope.row.identityAuth.identityState == 0 ? "未提交" : scope.row.identityAuth.identityState == 1 ? "待审核" : scope.row.identityAuth.identityState == 2 ? "审核通过" : scope.row.identityAuth.identityState == 3 ? "审核不通过" : scope.row.identityAuth.identityState == 4 ? "正面认证不通过" : scope.row.identityAuth.identityState == 5 ? "反面认证不通过" : "未知类型"}}</p>
              <p>芝麻认证：{{scope.row.identityAuth.zhimaState == 0 ? "认证失败" : scope.row.identityAuth.zhimaState == 1 ? "认证成功" : ""}}</p>
              <p>百度认证：{{scope.row.identityAuth.baiduState == 0 ? "认证失败" : scope.row.identityAuth.baiduState == 1 ? "认证成功" : ""}}</p>
              <p>身份总状态：{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
            </template>
          </el-table-column>

          <el-table-column label="状态" v-if="checkColList.indexOf('状态') > -1" width="100">
            <template #default="scope">
              <div style="font-size: 12px; font-weight: bold">
                <p style="margin-bottom: 6px;">
                  <el-tag v-if="scope.row.isDel == 0" class="ml-2" type="success"><span style="font-size: 12px; font-weight: bold">展示中</span></el-tag>
                  <el-tag v-if="scope.row.isDel == 1" class="ml-2" type="warning"><span style="font-size: 12px; font-weight: bold">已隐藏</span></el-tag>
                  <el-tag v-if="scope.row.isDel == 2" class="ml-2" type="danger"><span style="font-size: 12px; font-weight: bold">已注销</span></el-tag>
                </p>
                <p>{{!scope.row.pdesc?'未提交':scope.row.resumeState == 0?'待审核':scope.row.resumeState == 1?"待审核":scope.row.resumeState == 2?"审核通过":scope.row.resumeState == 3?"审核不通过":""}}</p>
                <p>{{scope.row.openState == 0?'待补全信息':scope.row.openState == 1?'待公开':scope.row.openState == 2?"公开-手动":scope.row.openState == 3?"不公开-手动":scope.row.openState == 4?"公开-头像机审":scope.row.openState == 5?"不公开-头像机审":""}}</p>
                <p v-if="scope.row.isForbidden" style="color: red">已封号</p>
                <p v-if="scope.row.isBannedChat" style="color: red">已禁言</p>
                <p v-if="scope.row.screenState == 1" style="color: red">已屏蔽</p>
                <p v-if="scope.row.isAbnormal" style="color: red">异常用户</p>
                <p v-if="scope.row.isIdfaBan" style="color: red">设备已冻结</p>
                <p v-if="scope.row.userSetting.isHiding" style="color: red">已隐身</p>
                <p :style="{color:scope.row.focusState > 3?'red':'#aaaaaa' }">{{
                    scope.row.focusState == 0?'未关注':
                    scope.row.focusState == 1?"已关注":
                    scope.row.focusState == 2?"自动取消关注":
                    scope.row.focusState == 3?"手动取消关注":
                    scope.row.focusState == 4?"已关注-封号":
                    scope.row.focusState == 5?"已关注-手动":
                    scope.row.focusState == 6?"已关注-设备异常":
                    scope.row.focusState == 7?"已关注-IP异常":
                    scope.row.focusState == 8?"已关注-订单异常":
                    scope.row.focusState == 9?"已关注-省份不一致":""
                  }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="100" fixed="right">
            <template #default="scope">
<!--              <el-space direction="vertical" alignment="left" :size="6">-->

<!--                <el-button v-if="scope.row.isDel==1" type="success" size="small" v-loading="scope.row.delLoading" @click="updateResumeDelState(scope.$index, scope.row, 0, '取消隐藏')">取消隐藏</el-button>-->
<!--                <el-button v-if="scope.row.isDel==0" type="primary" size="small" v-loading="scope.row.delLoading" @click="updateResumeDelState(scope.$index, scope.row, 1, '隐藏')">隐藏</el-button>-->
<!--                <el-button v-if="scope.row.isDel==2" type="success" size="small" v-loading="scope.row.delLoading" @click="updateResumeDelState(scope.$index, scope.row, 0, '取消注销')">取消注销</el-button>-->
<!--                <el-button v-if="scope.row.isDel==0 || scope.row.isDel==1" type="primary" size="small" v-loading="scope.row._delLoading" @click="updateResumeDelState(scope.$index, scope.row, 2, '注销')">注销</el-button>-->
<!--                <el-button v-if="!scope.row.isForbidden" type="primary" size="small" @click="updateUserForbidden(scope.$index, scope.row, 1)" v-loading="scope.row['forbiddenLoading']">封号</el-button>-->
<!--                <el-button v-if="scope.row.isForbidden" type="success" size="small" @click="updateUserForbidden(scope.$index, scope.row, 2)" v-loading="scope.row['forbiddenLoading']">解除封号</el-button>-->
<!--                <el-button v-if="!scope.row.isAbnormal" type="primary" size="small" @click="updateAbnormal(scope.$index, scope.row, 1)" v-loading="scope.row['_forbiddenLoading']">标记异常</el-button>-->
<!--                <el-button v-if="scope.row.isAbnormal" type="success" size="small" @click="updateAbnormal(scope.$index, scope.row, 2)" v-loading="scope.row['_forbiddenLoading']">取消异常</el-button>-->
<!--                <el-button v-if="!scope.row.isIdfaBan" type="primary" size="small" @click="updateUserIdfaBan(scope.$index, scope.row, 0)" v-loading="scope.row['isIdfaBanLoading']">冻结设备</el-button>-->
<!--                <el-button v-if="scope.row.isIdfaBan" type="success" size="small" @click="updateUserIdfaBan(scope.$index, scope.row, 1)" v-loading="scope.row['isIdfaBanLoading']">解除冻结</el-button>-->
<!--                <el-button v-if="scope.row.isBannedChat" type="success" size="small" @click="updateBannedChat(scope.$index, scope.row, 2)" v-loading="scope.row['bannedLoading']">解除禁言</el-button>-->
<!--                <el-button v-if="!scope.row.isBannedChat" type="primary" size="small" @click="updateBannedChat(scope.$index, scope.row, 1)">禁言</el-button>-->
<!--                <el-button v-if="scope.row.screenState == 0" type="primary" size="small" @click="updateScreenState(scope.$index, scope.row, 1)" v-loading="scope.row['screenLoading']">屏蔽</el-button>-->
<!--                <el-button v-if="scope.row.screenState == 1" type="success" size="small" @click="updateScreenState(scope.$index, scope.row, 0)" v-loading="scope.row['screenLoading']">取消屏蔽</el-button>-->
                <ActionButton :row="scope.row" :showList="'hide,cancel,forbidden,abnormal,idfa,chat,screen,point,quality,focus,' + (!isLinlu?'homeMatch':'')"/>
                <el-button type="primary" size="small" @click="updateResume(scope.$index, scope.row)">修改资料</el-button>
<!--                <AppointAuth :row="scope.row" />-->
<!--              </el-space>-->
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="170">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
          <el-table-column property="" label="视频" v-if="checkColList.indexOf('视频') > -1" width="70">
            <template #default="scope">
              <div v-if="scope.row.authVideo">
                <i v-if="scope.row.authVideo.state == 2" class="fa fa-play-circle fa-4x playBtn" aria-hidden="true" @click="onPlay(scope.row.authVideo.videoId)"></i>
                <p v-else>{{scope.row.authVideo.state == 0 ? '未上传' : scope.row.authVideo.state == 1 ? '待审核' : scope.row.authVideo.state == 2 ? '已通过' : scope.row.authVideo.state == 3 ? '不通过' : ''}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="" label="理想的另一半" v-if="checkColList.indexOf('理想的另一半') > -1" min-width="170" class-name="cursor">
            <template #default="scope">
              <p>{{ scope.row.idealHim }}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="闲暇喜好" v-if="checkColList.indexOf('闲暇喜好') > -1" min-width="170" class-name="cursor">
            <template #default="scope">
              <p>{{ scope.row.hobby }}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="信息标签" v-if="checkColList.indexOf('信息标签') > -1" min-width="200">
            <template #default="scope">
              <div v-if="scope.row.userTagList">
                <p class="tag-title">关于我：</p>
                <el-tag class="tap-item" v-for="(item,index) in scope.row.userTagListMe" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag>
                <p class="tag-title">理想的Ta：</p>
                <el-tag class="tap-item" v-for="(item,index) in scope.row.userTagListTa" size="small" effect="plain" :key="index" type="info">{{item.tag}}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="createTime" label="注册时间" v-if="checkColList.indexOf('注册时间') > -1" min-width="84"/>
          <el-table-column property="" label="类型" v-if="checkColList.indexOf('类型') > -1" width="70">
            <template #default="scope">
              {{scope.row.resumeState == 0?'首次':'非首次'}}
            </template>
          </el-table-column>
          <el-table-column property="" label="评分" v-if="checkColList.indexOf('评分') > -1" width="80">
            <template #default="scope">
              <el-tag v-if="scope.row.scoreState == 2" class="ml-2" type="success"><span style="font-size: 14px; font-weight: bold">{{ scope.row.score }}分</span></el-tag>
              <p v-else>未评分</p>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import ActionButton from "@/components/resume/ActionButton";
import ImgViewer from '../../assets/js/imageViewer'
import {
  getResumePageList,
  updateDelState,
  updateShowState,
  updateForbiddenState,
  updateResumeState,
  addBannedChat,
  updatePairState,
  listPackageNameAndChannel,
  updateUserBannedChat,
  updateUserForbidden,
  updateScreenState, updateResumeDelState, delUserSpecials,
  updateUserIdfaBan, getSpecialsList, getScoreList, updateResumeOpenState,updateRecommendScore
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import resumeRejectDialog from './components/resume/resumeRejectDialog'
import updateResumeDialog from './components/resume/updateResumeDialog'
import {common} from "@/assets/shared/select-constant";
import SendSystemMessageChat from "@/components/SendSystemMessageChat";
import BannedChatDialog from "@/components/resume/BannedChatDialog";
import PairDialog from "@/views/review/components/PairDialog";
import VideoPlay from "@/components/VideoPlay";
import ForbiddenDialog from "@/components/resume/ForbiddenDialog";
import AppointAuth from "@/components/resume/AppointAuth";
import HeadImgList from './components/resume/HeadImgList';
import SpecialDialog from "@/views/review/components/resume/SpecialDialog";
import ScoreDialog from "@/views/review/components/resume/ScoreDialog";
import GetPlain from "@/components/resume/GetPlain";
import ChannelPackageList from "@/components/resume/ChannelPackageList_c";
import voucherAwardDialog from "@/views/review/components/resume/voucherAwardDialog";
import updatePdescDialog from "@/views/review/components/resume/updatePdescDialog";
import { positiveIntReg } from "@/assets/shared/reg-constant";
import HeadImgResume from "@/components/HeadImgResume";
import imageList from "@/components/imageList";


export default {
name: "ReviewResume",
  components: { DatePickerRange, SearchComponents, UserLog, AppointAuth, GetPlain, ChannelPackageList, ActionButton, HeadImgResume },
  data() {
    return {
      // operateState: JSON.parse(sessionStorage.getItem('operateState')), //权限

      isOnly: false,
      isLinlu: false,

      sexArray: common.sexList,
      sex: common.sexList[2]['value'],

      identityStateArray: [
        {label: '不限制',value: -1},
        {label: '未提交',value: 0},
        {label: '待审核',value: 1},
        {label: '审核通过',value: 2},
        {label: '审核不通过',value: 3}
      ],
      identityState: -1, //身份认证
      overallAuthState: 2, //身份认证总状态

      //芝麻认证
      zhimaStateArray: [
        {label: '不限', value: -1},
        {label: '认证成功', value: 1},
        {label: '认证失败', value: 0},
      ],
      zhimaState: -1,

      //百度认证
      baiduStateArray: [
        {label: '不限', value: -1},
        {label: '认证成功', value: 1},
        {label: '认证失败', value: 0},
      ],
      baiduState: -1,

      //提交类型
      submitTypeArray: [
        {label: "不限制",value: -1},
        {label: "首次",value: 0},
        {label: "非首次",value: 1}
      ],
      submitType: -1,

      //进入
      enterStateArray: [
        {label: '不限', value: -1},
        {label: '未进入', value: 0},
        {label: '已进入', value: 1}
      ],
      enterState: -1,

      //信息审核状态
      resumeStateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '不通过', value: 3},
      ],
      resumeState: 1,

      //优质用户
      qualityStateArray: [
        {label: '不限', value: -1},
        {label: '优质用户', value: 1},
        {label: '非优质用户', value: 0},
      ],
      qualityState: -1,

      //首页推荐
      homeMatchArray: [
        {label: '不限', value: -1},
        {label: '推荐中', value: 1},
        {label: '不推荐', value: 0},
      ],
      homeMatch: -1,

      //隐身状态
      userSettingHidingArray: [
        {label: '不限', value: -1},
        {label: '已隐身', value: 1},
        {label: '未隐身', value: 0},
      ],
      userSettingHiding: -1,


      //公开
      openStateArray: [
        {label: '不限', value: -1},
        {label: '待补全信息', value: 0},
        {label: '待公开', value: 1},
        {label: '公开-手动', value: 2},
        {label: '不公开-手动', value: 3},
        {label: '公开-头像机审', value: 4},
        {label: '不公开-头像机审', value: 5},
      ],
      openState: -1,

      //封号类型
      forbiddenStateArray: [
        {label: '不限', value: -1},
        {label: '未封号', value: 0},
        {label: '已封号', value: 1},
      ],
      forbiddenState: 0,

      //用户类别
      userTagArray: [
        {label : '不限制', value : -1},
        {label : '付费认证', value : 1},
        {label : '临时交友', value : 2},
      ],
      userTag: -1,

      //推荐用户
      recommendArray: [
        {label : '不限', value : -1},
        {label : '推荐用户', value : 1}
      ],
      recommend: -1,

      //异常用户
      abnormalStateArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 0},
        {label: '信息异常', value: 1}
      ],
      abnormalState: -1,

      // 用户IP状态
      ipStateArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 0},
        {label: '异常', value: 1},
        {label: '异常变为正常', value: 2}
      ],
      ipState: -1,

      timeTypeArray: [
        {label: '更新时间', value: 1},
        {label: '注册时间', value: 2},
      ],
      timeType: 1,

      //年龄异常
      ageAbnormalArray: [
        {label: '不限', value: -1},
        {label: '年龄异常', value: 2},
        {label: '未处理', value: 0},
        {label: '年龄正常', value: 1},
      ],
      ageAbnormal: -1,

      //VIP类型
      vipStateArray: [
        {label : '不限制', value : -1},
        {label : '非vip', value : 1},
        {label : 'vip未过期', value : 2},
        {label : 'vip已过期', value : 3},
        {label : '终身vip', value : 4}
      ],
      vipState: -1,

      //隐藏用户
      delArray: [
        {label : '不限制', value : -1},
        {label : '未隐藏', value : 0},
        {label : '隐藏中', value : 1},
        {label : '已注销', value : 2},
        {label : '未注销', value : 3}
      ],
      del: 3,

      //后台评分
      scoreIdArray: [
        {label : '不限', value : -1},
        {label : '未评分', value : 0},
      ],
      scoreId: -1,
      scoreList: [],
      scoreMan: [],
      scoreWoman: [],

      //专区
      specialIdArray: [
        {label : '不限', value : -1},
      ],
      specialId: -1,
      specialAbduce: false,
      specialList: [],
      specialMan: [],
      specialWoman: [],

      //渠道、包名
      packageName: 0,
      channel: 0,

      //更新时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //生日时间
      birthdayStartTime: '',
      birthdayEndTime: '',
      isBirthdayChecked: true,

      //封号时间
      forbiddenStartTime: '',
      forbiddenEndTime: '',
      isForbiddenChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['时间', '头像', '用户信息', '相册', '关于我/自我介绍', '理想的另一半', '闲暇喜好', '信息标签', '认证状态',  '状态', '操作', '用户日志',  '视频','注册时间', '类型', '评分'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,
      openLoading: false,
      notOpenLoading: false,

      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4},
        {label : '身份证号', value : 5},
        {label : '实名', value : 6},
        {label : '融云ID', value : 7},
        {label : '自我介绍', value : 8},
      ],

      limitState: false,

      idArray: [],
      //选中性别
      userSexArray: [],

      // channelIdArray: [
      //   {label: '不限', value: -1},
      // ],
      // iosList: [],
      // androidList: [],
      // channelId: -1,

      //排序
      // sort: 1,

      //关注类型
      focusStateArray: [
        {label: '不限', value: -1},
        {label: '未关注', value: 0},
        {label: '已关注', value: 1},
        {label: '自动取消关注', value: 2},
        {label: '手动取消关注', value: 3},
        {label: '已关注-封号', value: 4},
        {label: '已关注-手动', value: 5},
        {label: '已关注-设备异常', value: 6},
        {label: '已关注-IP异常', value: 7},
        {label: '已关注-订单异常', value: 8},
        {label: '已关注-省份不一致', value: 9},
      ],
      focusState: -1,

      // 月收入
      salaryMinArray: [
        {label: '不限', value: -1}
      ],
      salaryMin: -1,
      salaryMaxArray: [
        {label: '不限', value: -1}
      ],
      salaryMax: -1,

      // 身高
      heightMinArray: [
        {label: '不限', value: -1}
      ],
      heightMin: -1,
      heightMaxArray: [
        {label: '不限', value: -1}
      ],
      heightMax: -1,

      annualSalary: -1,
      annualSalaryList: [
        {name: '不限', type: -1}
      ],

      //学历认证
      eduAuthStateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待认证', value: 1},
        {label: '已认证', value: 2},
        {label: '认证失败', value: 3},
      ],
      eduAuthState: -1,

    }
  },
  // computed: {
  //   colList() {
  //     if ( (this.operateState & 4) == 4) {
  //       return ['更新时间', '头像', '基本信息', '个性签名', '认证状态', '状态', '操作', '用户日志', '注册时间']
  //     } else {
  //       return ['更新时间', '头像', '基本信息', '个性签名', '认证状态', '用户日志', '注册时间']
  //     }
  //   }
  // },
  methods: {

    rowKey (row) {
      return row.userId;
    },

    //排序
    // sortChange(column) {
    //   if(column.prop == 'updateTime') {
    //     if(column.order == 'descending') {
    //       this.sort = 1;
    //     } else if(column.order == 'ascending') {
    //       this.sort = 2;
    //     }
    //   } else if(column.prop == 'regTime') {
    //     if(column.order == 'descending') {
    //       this.sort = 3;
    //     } else if(column.order == 'ascending') {
    //       this.sort = 4;
    //     }
    //   }
    //   this.getPage();
    // },

    // 月收入list
    getIncome() {
      let arr = [];
      for(let i = 2; i <= 50; i++) {
        arr.push({label : i + 'k', value : i})
      }
      this.salaryMinArray = this.salaryMinArray.concat(arr);
      this.salaryMaxArray = this.salaryMaxArray.concat(arr);
    },

    // 身高
    getHeight() {
      let arr = [];
      for(let i = 145; i <= 200; i++) {
        arr.push({label : i + 'cm', value : i})
      }
      this.heightMinArray = this.heightMinArray.concat(arr);
      this.heightMaxArray = this.heightMaxArray.concat(arr);
    },

    //渠道包名
    getChannelPackage(val) {
      // console.log(val)
      this.packageName = val[0];
      this.channel = val[1];
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getBirthdayTime(val) {
      this.birthdayStartTime = val[0];
      this.birthdayEndTime = val[1];
      // console.log(val)
    },

    getBirthdayCheck(val) {
      this.isBirthdayChecked = val
    },

    getForbiddenTime(val) {
      this.forbiddenStartTime = val[0];
      this.forbiddenEndTime = val[1];
      // console.log(val)
    },

    getForbiddenCheck(val) {
      this.isForbiddenChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.isBirthdayChecked = true;
      this.isForbiddenChecked = true;
      this.sex = 2;
      this.identityState = -1;
      this.overallAuthState = 2;
      this.zhimaState = -1;
      this.baiduState = -1;
      this.submitType = -1;
      this.enterState = -1;
      this.resumeState = 1;
      this.openState = 0;
      this.forbiddenState = 0;
      this.userTag = -1;
      this.recommend = -1;
      this.abnormalState = -1;
      this.ipState = -1;
      this.ageAbnormal = -1;
      this.vipState = -1;
      this.del = 3;
      this.scoreId = -1;
      this.specialId = -1;
      this.qualityState = -1;
      this.homeMatch = -1;
      this.userSettingHiding = -1;
      this.packageName = 0;
      this.channel = 0;
      this.searchValue = '';
      this.focusState = -1;
      this.salaryMin = -1;
      this.salaryMax = -1;
      this.heightMin = -1;
      this.heightMax = -1;
      this.annualSalary = -1;
      this.eduAuthState = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
      this.userSexArray = sels.map(item => item.sex);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        // this.idArray = [];
        // this.userSexArray = [];
        this.$refs.multipleTableRef.clearSelection();
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['birthdayStartTime'] = this.birthdayStartTime;
      param['birthdayEndTime'] = this.birthdayEndTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['overallAuthState'] = this.overallAuthState;
      param['submitType'] = this.submitType;
      param['enterState'] = this.enterState;
      param['openState'] = this.openState;
      param['forbiddenState'] = this.forbiddenState;
      param['userTag'] = this.userTag;
      param['recommend'] = this.recommend;
      param['abnormalState'] = this.abnormalState;
      param['ipState'] = this.ipState;
      param['ageAbnormal'] = this.ageAbnormal;
      param['vipState'] = this.vipState;
      param['del'] = this.del;
      param['scoreId'] = this.scoreId;
      param['specialId'] = this.specialId;
      param['packageNameId'] = this.packageName;
      param['channelId'] = this.channel;
      param['resumeState'] = this.resumeState;
      param['identityState'] = this.identityState;
      param['zhimaState'] = this.zhimaState;
      param['baiduState'] = this.baiduState;
      param['qualityState'] = this.qualityState;
      param['homeMatch'] = this.homeMatch;
      param['userSettingHiding'] = this.userSettingHiding;
      param['limitState'] = this.limitState?1:0;
      param['specialAbduce'] = this.specialAbduce?1:0;
      param['focusState'] = this.focusState;
      param['salaryMin'] = this.salaryMin;
      param['salaryMax'] = this.salaryMax;
      param['heightMin'] = this.heightMin;
      param['heightMax'] = this.heightMax;
      param['forbiddenStartTime'] = this.forbiddenStartTime;
      param['forbiddenEndTime'] = this.forbiddenEndTime;
      param['annualSalary'] = this.annualSalary;
      param['eduAuthState'] = this.eduAuthState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getResumePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.map(item => {
            if(item.userTagList) {
              item.userTagListMe = []
              item.userTagListTa = []
              for(let i=0; i<item.userTagList.length; i++) {
                if(item.userTagList[i].type == 1) {
                  item.userTagListMe.push(item.userTagList[i])
                }else {
                  item.userTagListTa.push(item.userTagList[i])
                }
              }
            }
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '关于我/自我介绍') {
        Dialog.open({
          title: '你正在查看用户【' + row.nickName + '】的自我介绍',
          component: updatePdescDialog,
          data: {
            pdesc: row.pdesc,
            userId: row.userId,
            width: '600px'
          },
          confirm: (result) => {
            row.pdesc = result;
          }
        })
      }

    },

    //展示、隐藏、注销
    updateResumeDelState(idx, row, state, type) {
      this.$confirm('确认' + type + '用户【' + row.nickName + '】简历？').then(() => {
        if(state == 2) {
          this.pageDataList[idx]['_delLoading'] = true
        } else {
          this.pageDataList[idx]['delLoading'] = true
        }
        let param = {};
        param['id'] = row.userId;
        param['del'] = state;
        let _this = this;
        postFormData(updateResumeDelState, param).then(function(data) {
          let code = data.code;
          let msg = data.msg;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList[idx]['isDel'] = state;
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx]['delLoading'] = false;
          _this.pageDataList[idx]['_delLoading'] = false;
        })
            .catch(function(response) {
              _this.pageDataList[idx]['delLoading'] = false;
              _this.pageDataList[idx]['_delLoading'] = false;
            })
      })
    },

    //批量更新封号状态
    // batchForbid() {
    //   if(this.idArray.length > 0) {
    //     this.$confirm('确认批量封号选中用户').then(()=>{
    //       this.bitchForbidLoading = true;
    //       let _this = this;
    //       let param = {};
    //       param['ids'] = this.idArray.toString();
    //       param['forbiddenState'] = 1;
    //       postFormData(updateForbiddenState, param).then((data) => {
    //         let {code, msg} = data;
    //         if(code == 200) {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'success'
    //           });
    //           for(let j=0;j<_this.idArray.length;j++){
    //             for(let i=0;i<_this.pageDataList.length;i++) {
    //               if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
    //                 _this.pageDataList.splice(i,1);
    //                 i--;
    //               }
    //             }
    //           }
    //           if(_this.pageDataList.length == 0){
    //             _this.getPage();
    //           }
    //         }else {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'warning'
    //           });
    //         }
    //         _this.bitchForbidLoading = false;
    //       })
    //           .catch(()=>{
    //             _this.bitchForbidLoading = false;
    //           })
    //     })
    //   }else {
    //     this.$message({
    //       showClose: true,
    //       duration: 1000,
    //       message: '请至少选择一个用户进行操作',
    //       type: 'warning'
    //     })
    //   }
    // },

    //更新封号
    updateUserForbidden(idx, row, state) {
      if(state == 1) {
        Dialog.open({
          title: '确定对用户【' + row.nickName + '】封号？',
          component: ForbiddenDialog,
          data: {
            userId: row.userId,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      } else if(state == 2) {
        this.$confirm('确定【取消封号】用户' +'【' + row.nickName + '】?').then(()=>{
          this.pageDataList[idx]['forbiddenLoading'] = true
          let param = {}
          param['id'] = row.userId
          param['state'] = state
          param['type'] = 99
          param['idfaBanState'] = 0
          postFormData(updateUserForbidden, param).then((data)=>{
            let {code, msg} = data
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              this.pageDataList[idx]['isForbidden'] = false
            }else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            this.pageDataList[idx]['forbiddenLoading'] = false
          }).catch(()=>{
            this.pageDataList[idx]['forbiddenLoading'] = false
          })
        })
      }
    },

    //标记异常
    updateAbnormal(idx, row, state) {
      this.$confirm('确定' + (state == 1?'标记异常':'取消标记异常') + '用户' +'【' + row.nickName + '】?').then(()=>{
        this.pageDataList[idx]['_forbiddenLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['state'] = state
        param['type'] = 3
        param['idfaBanState'] = 0
        postFormData(updateUserForbidden, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['isAbnormal'] = state == 1?true:false
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['_forbiddenLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['_forbiddenLoading'] = false
        })
      })
    },

    //冻结设备
    updateUserIdfaBan(idx, row, state) {
      this.$confirm('确定' + (state == 0?'冻结':'解冻') + '用户' +'【' + row.nickName + '】的设备?').then(()=>{
        this.pageDataList[idx]['isIdfaBanLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['state'] = state
        postFormData(updateUserIdfaBan, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['isIdfaBan'] = state == 0?true:false
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['isIdfaBanLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['isIdfaBanLoading'] = false
        })
      })
    },

    //更新简历状态
    batchPass() {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量通过选中用户').then(()=>{
          this.bitchPassLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['state'] = 2;
          param['warnMsg'] = '';
          param['warnTab'] = 0;
          postFormData(updateResumeState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }else {
                _this.$refs.multipleTableRef.clearSelection();
              }

            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.bitchPassLoading = false;
          })
              .catch(()=>{
                _this.bitchPassLoading = false;
              })
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    batchReject() {
      if(this.idArray.length > 0) {
        let _title = '批量不通过原因'
        let _this = this
        Dialog.open({
          title: _title,
          component: resumeRejectDialog,
          data: {
            idArray: this.idArray,
            width: '500px',
          },
          confirm: (()=>{
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }else {
              _this.$refs.multipleTableRef.clearSelection();
            }

          })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //公开、不公开
    batchOpen(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量' + (state == 2 ? '公开' : '不公开') + '操作？', {
          type: 'warning'
        })
            .then(() => {
              if(state == 2) {
                this.openLoading = true;
              } else {
                this.notOpenLoading = true;
              }
              let _this = this;
              let param = {};
              param['idArr'] = this.idArray;
              param['openState'] = state;
              postFormData(updateResumeOpenState, param).then(function(data) {
                let {code, msg} = data;
                if(code == 200) {
                  _this.$message({
                    showClose: true,
                    duration: 1000,
                    message: msg,
                    type: 'success'
                  })
                  for(let j=0;j<_this.idArray.length;j++){
                    for(let i=0;i<_this.pageDataList.length;i++) {
                      if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                        _this.pageDataList.splice(i,1);
                        i--;
                      }
                    }
                  }
                  if(_this.pageDataList.length == 0){
                    _this.getPage();
                  }else {
                    _this.$refs.multipleTableRef.clearSelection();
                  }

                } else {
                  _this.$message({
                    showClose: true,
                    duration: 1000,
                    message: msg,
                    type: 'warning'
                  });
                }
                _this.openLoading = false;
                _this.notOpenLoading = false;
              })
                  .catch(function(response) {
                    _this.openLoading = false;
                    _this.notOpenLoading = false;
                  })
            })
            .catch(() => {});
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        })
      }
    },

    //推荐、不推荐
    updateHomeMatch(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量设为' + (state == 1 ? '推荐用户' : '不推荐用户') + '？', {
          type: 'warning'
        })
            .then(() => {
              this.matchLoading = true;
              let _this = this;
              let param = {};
              param['idArr'] = this.idArray;
              param['homeMatch'] = state;
              postFormData(updateResumeUserSetting, param).then(function(data) {
                let {code, msg} = data;
                if(code == 200) {
                  _this.$message({
                    showClose: true,
                    duration: 1000,
                    message: msg,
                    type: 'success'
                  })
                  for(let j=0;j<_this.idArray.length;j++){
                    for(let i=0;i<_this.pageDataList.length;i++) {
                      if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                        _this.pageDataList.splice(i,1);
                        i--;
                      }
                    }
                  }
                  if(_this.pageDataList.length == 0){
                    _this.getPage();
                  }else {
                    _this.$refs.multipleTableRef.clearSelection();
                  }

                } else {
                  _this.$message({
                    showClose: true,
                    duration: 1000,
                    message: msg,
                    type: 'warning'
                  });
                }
                _this.matchLoading = false;
              })
                  .catch(function(response) {
                    _this.matchLoading = false;
                  })
            })
            .catch(() => {});
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        })
      }
    },

    //更新注销状态
    // updateDelState(idx, row, state) {
    //   this.$confirm('确定' + (state==1?'【注销】用户':'【取消注销】用户') +'【' + row.nickName + '】?').then(()=>{
    //     this.pageDataList[idx]['delStateLoading'] = true
    //     let param = {}
    //     param['userId'] = row.userId
    //     param['isDel'] = state
    //     postFormData(updateDelState, param).then((data)=>{
    //       let {code, msg} = data
    //       if(code == 200) {
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: msg,
    //           type: 'success'
    //         })
    //         this.pageDataList[idx]['isDel'] = state
    //       }else {
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: msg,
    //           type: 'warning'
    //         })
    //       }
    //       this.pageDataList[idx]['delStateLoading'] = false
    //     }).catch(()=>{
    //       this.pageDataList[idx]['delStateLoading'] = false
    //     })
    //   })
    // },

    //更新匹配状态
    // updatePairState(idx, row, state) {
    //   this.$confirm('确定' + (state==1?'【不匹配】用户':'【匹配】用户') +'【' + row.nickName + '】?').then(()=>{
    //     this.pageDataList[idx]['pairStateLoading'] = true
    //     let param = {}
    //     param['ids'] = row.userId
    //     param['pairState'] = state
    //     postFormData(updatePairState, param).then((data)=>{
    //       let {code, msg} = data
    //       if(code == 200) {
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: msg,
    //           type: 'success'
    //         })
    //         this.pageDataList[idx]['pairState'] = state
    //       }else {
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: msg,
    //           type: 'warning'
    //         })
    //       }
    //       this.pageDataList[idx]['pairStateLoading'] = false
    //     }).catch(()=>{
    //       this.pageDataList[idx]['pairStateLoading'] = false
    //     })
    //   })
    // },

    // updatePairDialog(idx, row) {
    //   Dialog.open({
    //     title: '匹配等级',
    //     component: PairDialog,
    //     data: {
    //       userId: row.userId,
    //       pairState: row.pairState,
    //       width: '500px'
    //     },
    //     confirm: (result) => {
    //       this.pageDataList[idx].pairState = result['pairState']
    //     }
    //   })
    // },

    //修改资料
    updateResume(idx, row) {
      let resumeForm = Object.assign({}, row)
      let _title = '编辑【' + row.nickName + '】的信息'
      Dialog.open({
        title: _title,
        component: updateResumeDialog,
        data: {
          resumeForm: resumeForm,
          width: '600px',
        },
        confirm: (result) => {
          row['sex'] = result.sex
          row['height'] = result.height
          row['sysBirthday'] = result.sysBirthday
          row['userSetting'].ipShow = result.ipShow
        },
      })
    },

    //历史头像
    openHeadImgList(row) {
      let _title = '【' + row.nickName + '】的历史头像'
      Dialog.open({
        title: _title,
        component: HeadImgList,
        data: {
          id: row.userId,
          width: '800px',
        },
        confirm: (result) => {
        },
      })
    },

    // showImg(row) {
    //   let imgList = []
    //   imgList.push(row.headImg.headImg)
    //   ImgViewer.open({
    //     imgList
    //   })
    // },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    //批量禁言
    batchBannedChat() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '禁言时间',
        component: BannedChatDialog,
        data: {
          userIdArray: this.idArray,
          width: '500px'
        },
        confirm: () => {
            this.getPage()
        }
      })
    },

    //单个禁言/解除
    updateBannedChat(idx, row, state) {
      let userIdArr = [];
      userIdArr.push(row.userId);
      if(state == 1) {
        Dialog.open({
          title: '禁言时间',
          component: BannedChatDialog,
          data: {
            userIdArray: userIdArr,
            width: '500px'
          },
          confirm: () => {
            row['isBannedChat'] = true
          }
        })
      }else if (state == 2) {
        this.$confirm('确定对用户【'+ row.nickName + '】解除禁言？')
            .then(() => {
              this.pageDataList[idx]['bannedLoading'] = true
              let param = {}
              param['idArr'] = userIdArr
              param['state'] = 2
              param['day'] = 0
              postFormData(updateUserBannedChat, param).then((data) => {
                let {code, msg} = data;
                if ( code == 200 ) {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'success'
                  })
                  this.pageDataList[idx]['isBannedChat'] = 0
                } else {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'warning'
                  })
                }
                this.pageDataList[idx]['bannedLoading'] = false
              }).catch(()=>{
                this.pageDataList[idx]['bannedLoading'] = false
              })
            })
            .catch(() => {
              // catch error
            })
      }
    },

    //更新屏蔽状态
    updateScreenState(idx, row, state) {
      this.$confirm('确定' + (state==1?'【屏蔽】用户':'【取消屏蔽】用户') +'【' + row.nickName + '】?').then(()=>{
        this.pageDataList[idx]['screenLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['screenState'] = state
        postFormData(updateScreenState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['screenState'] = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['screenLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['screenLoading'] = false
        })
      })
    },


    //视频
    onPlay(id) {
      Dialog.open({
        title: '视频播放',
        component: VideoPlay,
        data: {
          videoId: id,
        }
      })
    },

    //取消专区
    removeSpecialUser(userIdx, specialIdx) {
      this.$confirm('请确认是否继续移除操作', {
        type: 'warning'
      }).then(() => {
        let _this = this;
        let param = {};
        param['userId'] = this.pageDataList[userIdx]['userId'];
        param['specialsId'] = this.pageDataList[userIdx]['specialsUserList'][specialIdx]['id'];
        postFormData(delUserSpecials, param).then(function(data) {
          let {
            code,
            msg
          } = data;
          if(code == 200) {
            _this.pageDataList[userIdx]['specialsUserList'].splice(specialIdx, 1);
            _this.$message({
              showClose: true,
              duration: 1000,
              message: '操作成功',
              type: 'success'
            });
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
        })
            .catch(function(response) {})
      })
          .catch(() => {

          })
    },

    /**
     * @description 奖励代金券给选中的用户
     * @author
     * @memberof ResumeComponent
     */
    voucherAwardA() {
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '发送代金券',
          component: voucherAwardDialog,
          data: {
            idArray: this.idArray
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++){
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['userId'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0){
              this.getPage();
            }else {
              this.$refs.multipleTableRef.clearSelection();
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户发送代金券',
          type: 'warning'
        })
      }
    },

    /**
     * @description 用户专区操作
     * @author
     * @memberof ResumeComponent
     */
    updateSpecial() {
      if(this.idArray.length > 0) {
        let list = []
        let s = this.userSexArray[0]
        let isSex = this.userSexArray.every((val) => {
          return val == s;
        });
        if(!isSex) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: '勾选用户性别不一致，无法进行专区操作',
            type: 'warning'
          })
          return false
        } else {
          list = s==1?this.specialMan:this.specialWoman
        }
        Dialog.open({
          title: '专区选择',
          component: SpecialDialog,
          data: {
            idArray: this.idArray,
            specialList: list,
            width: '500px'
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++){
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['userId'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0){
              this.getPage();
            }else {
              this.$refs.multipleTableRef.clearSelection();
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    /**
     * @description 评分操作
     * @author
     * @memberof ResumeComponent
     */
    updateScore() {
      if(this.idArray.length > 0) {
        let list = []
        let s = this.userSexArray[0]
        let isSex = this.userSexArray.every((val) => {
          return val == s;
        });
        if(!isSex) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: '勾选用户性别不一致，无法进行专区操作',
            type: 'warning'
          })
          return false
        } else {
          list = s==1?this.scoreMan:this.scoreWoman
        }
        Dialog.open({
          title: '评分',
          component: ScoreDialog,
          data: {
            idArray: this.idArray,
            scoreList: list,
            width: '500px'
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++){
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['userId'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0){
              this.getPage();
            }else {
              this.$refs.multipleTableRef.clearSelection();
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    //获取专区列表
    getSpecial() {
      let param = {};
      param['sex'] = -1;
      let _this = this
      getFormData(getSpecialsList, param).then(function(data) {
        let { code, msg } = data;
        if(code == 200) {
          let dataList = data.data;
          dataList.map(item => {
            let sexStr = item.sex==1?'男':item.sex==2?'女':'';
            let obj ={}
            obj.label = item.name + '-' + sexStr
            obj.value = item.id
            _this.specialList.push(obj)
            if( item.sex == 1 ) {
              _this.specialMan.push(obj)
            } else {
              _this.specialWoman.push(obj)
            }
          })
          _this.specialIdArray = _this.specialIdArray.concat(_this.specialWoman)
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }

      })
          .catch(function(response) {})
    },

    //获取评分列表
    getScore() {
      let param = {};
      param['sex'] = -1;
      let _this = this
      getFormData(getScoreList, param).then(function(data) {
        let { code, msg } = data;
        if(code == 200) {
          let dataList = data.data;
          dataList.map(item => {
            let sexStr = item.sex==1?'男':item.sex==2?'女':'';
            let obj ={}
            obj.label = item.score + '-' + sexStr
            obj.value = item.id
            obj.msg = item.msg
            _this.scoreList.push(obj)
            if( item.sex == 1 ) {
              _this.scoreMan.push(obj)
            } else {
              _this.scoreWoman.push(obj)
            }
          })
          _this.scoreIdArray = _this.scoreIdArray.concat(_this.scoreWoman)
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }

      })
          .catch(function(response) {})
    },

    sexChange(val) {
      this.specialIdArray = [
        {label : '不限', value : -1},
      ]
      this.specialId = -1
      this.scoreIdArray = [
        {label : '不限', value : -1},
        {label : '未评分', value : 0},
      ]
      this.scoreId = -1
      if(val == -1) {
        this.specialIdArray = this.specialIdArray.concat(this.specialList)
        this.scoreIdArray = this.scoreIdArray.concat(this.scoreList)
      } else if (val == 1) {
        this.specialIdArray = this.specialIdArray.concat(this.specialMan)
        this.scoreIdArray = this.scoreIdArray.concat(this.scoreMan)
      } else if (val == 2) {
        this.specialIdArray = this.specialIdArray.concat(this.specialWoman)
        this.scoreIdArray = this.scoreIdArray.concat(this.scoreWoman)
      }
    },

    /**
     * @description 添加推荐
     * @author
     * @param {number} idx
     * @param {*} score 需要添加的推荐分数
     * @memberof ResumeComponent
     */
    addRecommend(idx, row) {
      let score = row.recommendScore
      if(!positiveIntReg.test(score)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交大于零的合法推荐分数',
          type: 'warning'
        });
      } else {
        this.$confirm('确认为用户【' + row['nickName'] + "】添加“" + score + "分”的推荐分数", {
          type: 'warning'
        }).then(() => {
          let _this = this;
          let param = {};
          param['id'] = row.userId;
          param['score'] = score;
          postFormData(updateRecommendScore, param).then(function(data) {
            let {
              code,
              msg
            } = data;
            if(code == 200) {
              row['recommendScore'] = score;
              row['scoreSub'] = false;
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
            } else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
          })
              .catch(function(response) {})
        })
      }
    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    showImgList(row) {
      Dialog.open({
        title: '【' + row.nickName + '】的相册',
        component: imageList,
        data: {
          imgList: row.photoList,
          width: '1000px'
        }
      })
    },



  },
  mounted() {
    // if(window.location.hostname == 'only.backstage.yiban1314.com'  || window.location.port == '20030'  || window.location.hostname == 'backstage.youban1314.cn') {
    //   this.isOnly = true
    // }
    if(window.location.hostname == 'only.backstage.yiban1314.com') {
      this.isOnly = true
    }
    if(window.location.hostname == 'backstage.youban1314.cn' || window.location.port == '20030' ) {
      this.isLinlu = true
    }
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage(true);
    this.getSpecial();
    this.getScore();
    this.getIncome();
    this.getHeight();
  }
}
</script>

<style scoped>
.playBtn {
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  color: #409eff;
}
.scoreInput {
  border: none;
  height: 1.2em;
  width: 3.2em;
  border-radius: 3px;
  background-color: #ffffff;
  text-align: center;
  /*font-weight: bold;*/
  padding: 2px;
  color: #3a8ee6;
  outline: 0.12em dashed #e1e1e1;
}
.scoreBtn {
  background-color: #3a8ee6;
  width: 1.5em;
  height: 1.5em;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  cursor: pointer;
}
input[type=text]:focus{ outline: 0.12em solid #3a8ee6;}
input::-webkit-input-placeholder{   /* 使用webkit内核的浏览器 */
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
}
input:-moz-placeholder{    /* Firefox版本4-18 */
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
}
input::-moz-placeholder{    /* Firefox版本19+ */
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
}
input:-ms-input-placeholder{   /* IE浏览器 */
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
}
.tag-title {
  font-size: 12px;
  margin-bottom: 4px;
}
.tap-item {
  margin: 0 4px 4px 0;
  /*display: inline-block;*/
}

.history-btn {
  color: #409eff;
  cursor: pointer;
  width: 78px;
  text-align: center;
  padding: 2px 0;
  border: 1px solid #409eff;
  border-radius: 4px;
  font-size: 12px;
}
.img-now-tag {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.6);
  color: #ffffff;
  font-size: 12px;
  padding: 2px 10px;
  z-index: 99;
  /*font-weight: bold;*/
  border-radius: 0 0 8px 0;
  letter-spacing: 1px;
}

.img-history-tag {
  width: 80px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.6);
  color: #ffffff;
  font-size: 11px;
  padding: 2px 0;
  z-index: 99;
  /*font-weight: bold;*/
  letter-spacing: 1px;
  text-align: center;
}

.photo-tip {
  text-align: center;
  margin-top: 8px;
  cursor: pointer
}

.photo-tip:hover {
  color: #409eff;
}

</style>
